module.exports = __webpack_public_path__ + "static/shopify_paypal-f233aa5608abb20d1633f1edec669cd7.svg";